import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async pesquisarCeps(api, parametros) {    
    parametros.operacao = 'pesquisarCeps';    
  
    let retorno = {};

    await api.santriPOST('/rest/cep', parametros, 10, true)
    .then(response => {
     retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
     retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarCepPorId(api, parametros) {    
    parametros.operacao = 'buscarCepPorId';    
  
    let retorno = {};

    await api.santriGET('/rest/cep', parametros, 10, true)
    .then(response => {
     retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
     retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RCep.js